export const genres: string[] = [
  "科幻",
  "悬疑",
  "犯罪",
  "剧情",
  "爱情",
  "喜剧",
  "动作",
  "冒险",
  "奇幻",
  "古装",
  "历史",
  "青春",
  "动画",
  "家庭",
  "惊悚",
  "西部",
  "谍战",
  "职业",
  "文艺",
];

export const regions: string[] = [
  "中国大陆",
  "中国香港",
  "美国",
  "英国",
  "韩国",
  "日本",
  "法国",
];

export const years: number[] = [2026, 2025, 2024, 2023, 2022];